import { AbstractControl, ValidationErrors } from '@angular/forms';

export function maxFileSizeValidator(fileSizeInMB: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as File[] | null;
    if (!files?.length) return null;

    const invalidIndexes = files
      .map((file, i) => (file.size / 1024 / 1024 > fileSizeInMB ? i : -1))
      .filter(i => i !== -1);

    return invalidIndexes.length > 0 ? { maxFileSize: invalidIndexes } : null;
  };
}
